import { useState } from 'react'
import { useDebounceSearch } from '../../hooks/useDeboucedSearch'
import { TextInput } from './textInput'

export const SearchInput = ({
  searchFunction,
  placeholder = 'Search',
  className = '',
  useDefaultTextAppearance = false,
  hasIcon = true,
  initialValue,
  ariaLabel,
}: {
  searchFunction: (val: string) => void
  placeholder?: string
  className?: string
  useDefaultTextAppearance?: boolean
  hasIcon?: boolean
  initialValue?: string
  ariaLabel?: string
}) => {
  const [searchParams, setSearchParams] = useState<string | undefined>(
    initialValue,
  )

  useDebounceSearch({
    searchQuery: searchParams,
    onSearch: (query) => {
      searchFunction(query as string)
    },
  })

  return (
    <TextInput
      placeholder={placeholder}
      aria-label={ariaLabel ?? placeholder}
      hasIcon={hasIcon}
      iconSvg="search"
      iconDimension={18}
      className={`
            ${
              !useDefaultTextAppearance &&
              `!bg-gray-bg !rounded-[32px] !border-transparent placeholder:!text-neutral !py-3 !text-base !font-normal`
            }
          `}
      value={searchParams}
      onChange={(e) => {
        setSearchParams(e.target.value)
      }}
      containerClassName={`max-w-[300px] ${className}`}
    />
  )
}
